module.exports = __webpack_public_path__ + "img/1.26d846dc.png";